import { LineChart as RLine, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { colors } from '../../lib/colors';

interface Props {
  data: Record<string, any>[];
  xKey: string;
  yKey: string;
  height?: number;
}

export function LineChart({ data, xKey, yKey, height = 320 }: Props) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <RLine data={data} margin={{ top: 8, right: 16, left: 0, bottom: 8 }}>
        <CartesianGrid stroke={colors.borderLight} vertical={false} />
        <XAxis dataKey={xKey} stroke={colors.textMuted} fontSize={11} tickLine={false} axisLine={{ stroke: colors.border }} />
        <YAxis stroke={colors.textMuted} fontSize={11} tickLine={false} axisLine={{ stroke: colors.border }} />
        <Tooltip
          contentStyle={{ background: colors.surface, border: `0.5px solid ${colors.border}`, borderRadius: 8, fontSize: 12 }}
          cursor={{ stroke: colors.accent, strokeOpacity: 0.4 }}
        />
        <Line type="monotone" dataKey={yKey} stroke={colors.accent} strokeWidth={2} dot={{ fill: colors.accent, r: 3 }} />
      </RLine>
    </ResponsiveContainer>
  );
}
